<div class="search-empty-splash">
  <div class="header">
    No results for “{{searchValue}}”
  </div>

  <div class="splash-list">
    <div class="item">Check for typos and spelling errors</div>
    <div class="item">Try more general keywords</div>
    <div class="item">Try different keywords</div>
  </div>
</div>
